module.exports = __webpack_public_path__ + "img/Startseite.c8c568db.png";